module.exports = __webpack_public_path__ + "img/tableau_covid_vaccin_en.fb105a06.jpg";